module.exports = __webpack_public_path__ + "static/media/close.c060470e.png";